// Intervals are milliseconds computed from consecutive sample-normalized spikes.
// Explicit bars keep empty/long-interval datasets from receiving Plotly's
// misleading empty-histogram 0–1 defaults.
export function buildCuratorIsiHistogram(intervals, { maximumMs = '', binMs = '' } = {}) {
  const values = intervals.filter(value => Number.isFinite(value) && value >= 0);
  let minimum = Infinity, maximum = 0;
  values.forEach(value => { minimum = Math.min(minimum, value); maximum = Math.max(maximum, value); });
  const limit = maximumMs === '' ? Math.max(maximum, 2) : Number(maximumMs);
  const requestedBin = binMs === '' ? limit / 50 : Number(binMs);
  if (!Number.isFinite(limit) || limit <= 0 || !Number.isFinite(requestedBin) || requestedBin <= 0) {
    return { error: 'Enter a positive range and bin width, or leave them blank for automatic values.' };
  }
  // Bound plot complexity, not the input data: every valid interval is counted.
  const width = Math.max(requestedBin, limit / 2000);
  const bins = Math.max(1, Math.ceil(limit / width));
  const counts = Array(bins).fill(0);
  let included = 0;
  values.forEach(value => {
    if (value > limit) return;
    counts[Math.min(bins - 1, Math.floor(value / width))]++;
    included++;
  });
  const widths = counts.map((_, i) => Math.min(width, limit - i * width));
  return { x: counts.map((_, i) => i * width + widths[i] / 2), counts, widths,
    binWidthMs: width, maximumMs: limit, total: values.length, included,
    excluded: values.length - included, minimum: values.length ? minimum : null, maximum,
  };
}
